import en_US from './en_US';
import fr_CA from './fr_CA';

export default {
	'en-US': en_US,
	'fr-CA': fr_CA,
};



// WEBPACK FOOTER //
// ./src/ui/i18n/messages/index.js